// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-toggle-option{flex:1}:host([size='large']) > .mp-toggle.theme-segcon > .mp-toggle-option:first-child{border-radius:0}:host([size='large']) .mp-toggle.theme-segcon .mp-toggle-option:first-child > mp-button{border-radius:0}:host([size='large']) .mp-toggle.theme-segcon{border-radius:0 9px 9px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
